export default __webpack_public_path__ + "static/media/VOLVO.ba3990a5.png";